module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('h3', [_vm._v(_vm._s(_vm.msg) + "，获取到的参数是：" + _vm._s(_vm.$route.params.id))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42e44272!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 74
// module chunks = 2